
// We are relying on jQuery being called in a separate script file.
var $ = window.jQuery;


/* ==========================================================================
   IMPORTS - BOOTSTRAP MODULES
   ========================================================================== */

// import the Bootstrap javascript and the components used on the website.
// import '../../../bower_components/bootstrap-sass-official/assets/javascripts/bootstrap/affix'
// import '../../../bower_components/bootstrap-sass-official/assets/javascripts/bootstrap/alert'
// import '../../../bower_components/bootstrap-sass-official/assets/javascripts/bootstrap/button'
// import '../../../bower_components/bootstrap-sass-official/assets/javascripts/bootstrap/carousel'
// import '../../../bower_components/bootstrap-sass-official/assets/javascripts/bootstrap/collapse'; //! requires transition.js
// import '../../../bower_components/bootstrap-sass-official/assets/javascripts/bootstrap/dropdown'
import '../../../bower_components/bootstrap-sass-official/assets/javascripts/bootstrap/modal';
// import '../../../bower_components/bootstrap-sass-official/assets/javascripts/bootstrap/scrollspy'
// import '../../../bower_components/bootstrap-sass-official/assets/javascripts/bootstrap/tab'
// import '../../../bower_components/bootstrap-sass-official/assets/javascripts/bootstrap/transition';
import '../../../bower_components/bootstrap-sass-official/assets/javascripts/bootstrap/tooltip'
import '../../../bower_components/bootstrap-sass-official/assets/javascripts/bootstrap/popover' //! requires tooltip.js.

/* ==========================================================================
   IMPORTS - VENDORS
   ========================================================================== */

// import FastClick and call immediately for removing the 300ms touch delay.
import 'fastclick/lib/fastclick';
// import MotionUI from 'motion-ui/motion-ui';


// lightboxes: http://dimsemenov.com/plugins/magnific-popup/documentation.html
import '../../../bower_components/magnific-popup/dist/jquery.magnific-popup.js';


import MotionUI from '../../../bower_components/motion-ui/dist/motion-ui.js';
window.MotionUI = MotionUI;


// for making things equal height: http://brm.io/jquery-match-height/
import '../../../bower_components/matchHeight/dist/jquery.matchHeight.js';





/* ==========================================================================
   THEME ES6 COMPONENTS
   ========================================================================== */

import Toggler from './components/toggler.js';




/* ==========================================================================
   THEME ES6 COMPONENTS -- WOOCOMMERCE
   ========================================================================== */
import woocommerce from 'components/woocommerce/woocommerce'; // all custom woocommerce stuff is initialized in here.
import Navbars from './components/navbar-offcanvas';
import Searchbar from './components/animated-searchbar.js';
import Modals from './components/modals.js';
import './components/scroll-to-element.js';
import ShippingCalculator from 'components/shipping-calculator.js';
import detectIE from './components/add-ie-classes-to-body.js';



/* ==========================================================================
   App Functionality
   ========================================================================== */


class App {

    constructor() {
        this.setInitialState();
        this.setCache();
        this.bindEvents();
        this.initComponents();
        this.initFunctions();
    }

    setInitialState() {
        this.state = {
        };
    }

    setCache() {
        this.cache = {};
        this.cache.body = $(document.body); // lots of woocommerce events get fired here, so this is where we will be binding our events.
    }

    bindEvents() {
        $(document.body).on('shop_html_did_update', () => {

            $( '.variations_form' ).each( function() {
				$( this ).wc_variation_form();
			});

            this.initShopDropdowns();

            $(window).trigger('resize');
        });

        // Pick a different attribute when the default variation is out of stock
        $(document).on('check_variations', '.variations_form', function() {
            var $form = $(this);
            if($form.data('checked')) {
                return;
            }

            var $selects = $form.find('.variations select');
            var is_unavailable = $form.find('.wc-variation-is-unavailable').length > 0;

            if(is_unavailable) {
                $selects.val('');
                $selects.trigger('change');
            }

            $form.data('checked', true);
        });

    }

    initComponents() {

        // all woocommerce js is in its own file.
        // woocommerce();

        // navbars (horizontal inline menus) that turn into off-canvas-navs on mobile.
        new Navbars();

        // the header searchbar
        new Searchbar();

        new Modals();

        new Toggler();

        new ShippingCalculator();
    }


    initFunctions() {
        // make things the same height
        this.initMatchHeight();

        this.initGalleries();

        this.initMainMenu();

        this.initFooter();

        this.initNavbars();

        this.initPopovers();

        this.initShopDropdowns();

        this.initSubscribeBar();

    }


    initShopDropdowns() {
        var variationsForms = $('.tile__footer form.variations_form');

        variationsForms.each(function(index, el) {
            var form = $(el);

            if (!form.data('hasBeenModified')) {

                form.data('hasBeenModified', true);

                var variations = form.data('product_variations');
                var selects = form.find('select[data-attribute_name]');



                if (selects.length == 1) {
                    // add the price to the select options

                    var options = form.find('select[data-attribute_name] option');

                    var variation = false;

                    options.each(function(index, el) {
                        var option = $(el);
                        var selectAttribute = option.closest('select').data('attribute_name');
                        if (option.val()) {
                            $.each(variations, function(index, item) {
                                if (item.attributes && (item.attributes[selectAttribute] == option.val())) {
                                    option.text(option.text() + ' - $' + parseFloat(Math.round(item.display_price * 100) / 100).toFixed(2));
                                }
                            });
                        }



                    });
                }
            }
        });
    }



    // loose items that we just want to match height.
    initMatchHeight() {
        $('.js-stripe-stores-default .stripe__header, .js-stripe-stores-default .stripe__content').matchHeight();

        // this one affects a lot of things, so if it causes problems, you might need to go one by one.
        // $('.tiles .tile').matchHeight();

        // Article titles
        $('.tile--article').matchHeight();

        // region tiles (on product archive for example)
        $('.stripe--regions .tile__inner').matchHeight();

        // events tiles when they are half/half layout.
        $('.stripe--events--half .tile__inner').matchHeight();

        $('.tiles .woocommerce-LoopProduct-link').matchHeight();
        $('.tiles .product:not(product-category)').matchHeight();
    }

    // Init Image Galleries using our chosen lightbox plugin.
    initGalleries() {
        // initiates any gallery on the site.
        // if you use the Helpers()->the_acf_gallery() with links enabled, this will just work.
        $('.gallery--acf').each(function() { // the containers for all your galleries
            $(this).magnificPopup({
                delegate: '[data-mfp-src]', // the selector for gallery item
                type: 'image',
                gallery: {
                  enabled:true
                }
            });
        });

        // For the product thumbnails. This replaces the Pretty Photo functionality built in with woocommerce.
        $('.single-product__thumbnails, .single-product__image--main').magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    }

    initFooter() {

        var $body = $(document.body);

        $body.on('click', '.js-footer-nav-collapse-trigger', function(e) {
            e.preventDefault();
            var trigger = $(e.target);
            var parent = trigger.closest('.footer-nav').toggleClass('is-open-mobile');
        });

    }

    initNavbars() {
        $('.nav--primary .menu-item-has-children > a').on('click', function(e) {

            //e.preventDefault();
            // console.log("clicked for dropdown");

        });
    }

    // inits tooltips. These can be found on the store pages.
    initPopovers() {
        // this grabs the content for the tooltip, there is a selector in the html pointing to the correct content.
        var getPopoverContent = function() {
            var trigger = $(this);
            var data = trigger.data();
            var content = $(data.contentselector);
            return content.prop('outerHTML');
        }

        // stop jump when clicking on links with #
        $('.js-popover').on('click', function(e) { e.preventDefault();});

        // bootstrap tooltip init
        $('.js-popover').popover({
            content: getPopoverContent,
            placement: 'auto bottom',
            trigger: 'focus',
            html: true,
            template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>',
            delay: {show: 50, hide: 750},

        });
    }

    initMainMenu() {
        // TODO: this is a mess.
        var isOpen = false;
        var target = $('.js-mobile-menu');
        var trigger = $('.js-mobile-menu-trigger');
        var $body = $(document.body);

        trigger.on( 'click', function() {
            // console.log("click!");
            $body.trigger('toggle-mobile-menu');
        });


        function getOverlay() {
            var overlay = $('.js-overlay');

            if (!overlay.length) {
                var template = `<div class="overlay overlay--default js-overlay"></div>`;
                overlay = $(template).hide();
                $body.append(overlay);
            }

            return overlay;
        }

        var overlay = getOverlay();

        function closeMenu() {
            MotionUI.animateOut(overlay, 'fade-out fast');
            target.toggleClass('is-visible');
            $body.toggleClass('is-open-mobile-nav');
        }

        $body.on('toggle-mobile-menu', function() {
            // console.log("toggle mobile menu");
            $body.toggleClass('is-open-mobile-nav');
            target.toggleClass('is-visible');
            // target.find('.sub-menu').hide();
            overlay.one('click', closeMenu);

            MotionUI.animateIn(overlay, 'fade-in fast ease-in ');
        });

        $body.on('click', '.js-close-mobile-menu', closeMenu);


        function makeSubmenu(menuItems) {

            menuItems = menuItems.first().clone().wrap('<div>').parent().html();

            var template = `
                <div class="sub-menu--generated js-sub-menu-container" style="display:none">
                    <div class="sub-menu__header">
                        <a class="btn--back js-close-sub-menu"><span class="icon icon-chev-left"></span> Back</a>
                    </div>
                    <div class="sub-menu__content">
                        ${menuItems}
                    </div>
                </div>`;

            return $(template);
        }

        target.on('click', '.js-close-sub-menu', function() {
            var subMenu = target.find('.js-sub-menu-container');


            MotionUI.animateOut(subMenu, 'slide-out-right fast ease-in', () => {
                // console.log("closed sub menu");
                // add class is-open class after the animation is done
                // this.cache.container.addClass('is-open');
                // focus the input after animation
                // this.cache.container.find('input[type=search]').focus();
                subMenu.remove();
            });
        });
        



        target.on('click', '.menu-item-has-children > a', function(e) {
            e.preventDefault();
            // console.log("click submenu");
            var subMenu = $(e.target).closest('.menu-item').find('.sub-menu');

            subMenu = makeSubmenu(subMenu);

            target.append(subMenu);

            MotionUI.animateIn(subMenu, 'slide-in-right fast ease-in', () => {
                // console.log("opened sub menu");
                // add class is-open class after the animation is done
                // this.cache.container.addClass('is-open');
                // focus the input after animation
                // this.cache.container.find('input[type=search]').focus();
            });
        });


    }

    initSubscribeBar() {
        var Subscribe = {


            init : function() {

                this.cacheElements();
                this.bindUi();

                // toggle by default
                this.toggle();

            },

            cacheElements : function() {

                var $ = window.jQuery;

                this.elements = {
                    body : $(document.body),
                    form : $('.subscribe-bar__form'),
                    button : $('.subscribe-bar__form').find('.js-subscribe'),
                    close : $('.js-close-subscribe')
                };

            },

            bindUi : function() {
                this.elements.close.on('click', this.closeSubscribe.bind(this));

                $('.js-subscribe').on('click', this._processSubscription.bind(this));

                $(window).scroll( throttle(this.toggle.bind(this), 500, this));

            },

            toggle : function(bool) {

                // prevent the subscription bar from working
                if( ! Cookies.get('hide_subscribe_bar') ) {

                    if( $(window).scrollTop() > 0) {
                        this.showSubscribe();
                    } else {
                        this.hideSubscribe();
                    }

                }

            },

            _processSubscription : function(event) {

                event.preventDefault();

                // begin the processing state
                this.isProcessing();

                // get our nonce and email field
                var $input = this.elements.form.find('.js-subscribe-field');
                var $nonce = this.elements.form.find('#subscribe-bar-nonce');

                // only process if is email
                if( this.isEmail( $input.val() ) === true ) {

                    $.ajax({
                        context: this,
                        type: 'POST',
                        url: base_urls.ajaxurl,
                        datatype: 'JSON',
                        data: {
                            action: 'subscribe_newsletter',
                            email: $input.val(),
                            nonce: $nonce.val()
                        },
                    }).done(function(data) {

                        // convert response into json
                        var response = jQuery.parseJSON(data);

                        if( response.status ) {
                            this.isSuccess();
                            Cookies.set('hide_subscribe_bar', true, { expires: 30 });
                        } else {
                           this.isError(response.message);
                        }

                    }).fail(function(data) {
                        this.isError('An error occurred. Please try again');
                    });

                } else {
                    this.isError('Please enter your email address');
                }


            },

            // reset subscribe states
            resetStates : function() {
                this.elements.form.removeClass('is-processing is-success is-error');
                this.elements.form.find('.help-block').hide();
            },

            // default subscribe state
            isDefault : function() {
                this.resetStates();
                this.elements.button.html('Subscribe');
            },

            // processing subscribe state
            isProcessing : function() {
                this.resetStates();
                this.elements.form.addClass('is-processing');
                this.elements.button.html('<svg class="c-icon c-icon--spin"><use xlink:href="#spinner" /></svg></span>');
            },

            // success subscribe state
            isSuccess : function() {
                this.resetStates();
                this.elements.form.addClass('is-success');
                this.elements.button.html('<svg class="c-icon"><use xlink:href="#tick-bold" /></svg> Thankyou');

                var that = this;
                setTimeout(function(){
                    that.closeSubscribe();
                }, 2500);

            },

            // error subscribe state
            isError : function(text) {
                this.resetStates();
                this.elements.form.addClass('is-error');
                this.elements.button.html('Subscribe');
                this.elements.form.find('.help-block').html(text).show();
            },

            showSubscribe : function() {
                this.elements.body.addClass('subscribe-open');
            },

            hideSubscribe : function() {
                this.elements.body.removeClass('subscribe-open');
            },

            closeSubscribe : function() {
                this.hideSubscribe();
                Cookies.set('hide_subscribe_bar', true, { expires: 30 });
            },

            isEmail : function( email ) {
                var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return regex.test(email);
            }

        };


        Subscribe.init();

        function debounce(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this, args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        };

        function throttle(fn, threshhold, scope) {
          threshhold || (threshhold = 250);
          var last,
              deferTimer;
          return function () {
            var context = scope || this;

            var now = +new Date,
                args = arguments;
            if (last && now < last + threshhold) {
              // hold on to it
              clearTimeout(deferTimer);
              deferTimer = setTimeout(function () {
                last = now;
                fn.apply(context, args);
              }, threshhold);
            } else {
              last = now;
              fn.apply(context, args);
            }
          };
        }

    }

}


/* ==========================================================================
   DOCUMENT READY
   ========================================================================== */

$(document).ready(function(){

  detectIE();

  woocommerce();


    if (window.flexibility) {
        window.flexibility(document.body);
    }


      new App();
      
    $('.hamburger').click(function () {
        $(".hamburger").toggleClass('is-active');
        $("#nav").toggleClass("nav-active");
    });

    $('.toggle-mobile-links').click(function (event) {
        var windowW = $(window).width();
        if (windowW < 768) {
            event.preventDefault();
            $(this).toggleClass('active');
            $(this).find('.home-about__stores-list').slideToggle('1000');
        }
    });

    $('.home-about__stores-link-button').click(function (event) {
        var link = $(this).closest('.home-about__stores-item').attr('href');
        window.location.replace(link);
    });

    $('.toggle-footer-links').click(function (event) {
        var target = $(event.target);
        var windowW = $(window).width();
        if (windowW < 768) {
            $(this).toggleClass('active');
            $(this).children('ul').slideToggle('1000');
        }
    });

    $('.home-slider__body').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        dots: true,
        autoplaySpeed: 6000,
        speed: 1500,
        arrows: true,
    });

    $('.home-products-slider__body').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        dots: false,
        speed: 500,
        arrows: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true
                }
            }, {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true
                }
            }, {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true
                }
            }
        ]
    });

});
